import { Link } from 'react-router-dom';

interface ComicCardProps {
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categoryName: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  updatedAt: string;
  chapterCount: number;
  index?: number;
}

export default function ComicCard({
  slug,
  title,
  author,
  coverImage,
  description,
  category,
  categoryName,
  status,
  rating,
  views,
  updatedAt,
  chapterCount,
  index,
}: ComicCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/comic/${slug}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100">
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={`${title} - 韩国漫画网`}
          />
          <div className="absolute top-2 left-2 flex gap-1.5">
            {status === '已完结' && (
              <span className="px-2 py-0.5 text-xs font-medium rounded-full bg-foreground-800/80 text-background-50 whitespace-nowrap">
                已完结
              </span>
            )}
            {index !== undefined && index < 3 && (
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                {index + 1}
              </span>
            )}
          </div>
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-3">
            <p className="text-background-50 text-xs whitespace-nowrap">
              更新至 {chapterCount} 话
            </p>
          </div>
        </div>
        <div className="p-3">
          <h3 className="text-foreground-900 font-semibold text-sm leading-snug line-clamp-1 group-hover:text-primary-500 transition-colors">
            {title}
          </h3>
          <p className="text-foreground-500 text-xs mt-1">{author}</p>
          <p className="text-foreground-400 text-xs mt-1 line-clamp-2 leading-relaxed">{description}</p>
          <div className="flex items-center justify-between mt-2.5 pt-2.5 border-t border-background-200/70">
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-0.5 w-4 h-4">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
              </div>
              <span className="text-foreground-600 text-xs font-medium">{rating}</span>
            </div>
            <span className="text-foreground-400 text-xs">{formatViews(views)} 阅读</span>
          </div>
          <Link
            to={`/category/${category}`}
            className="inline-block mt-2 text-xs text-secondary-600 hover:text-secondary-800 transition-colors whitespace-nowrap"
            onClick={(e) => e.stopPropagation()}
          >
            {categoryName}
          </Link>
        </div>
      </div>
    </Link>
  );
}